window.initCustomSelect = function () {
    let $selectOpen = $('.js-custom-select__name');
    let $selectOption = $('.js-custom-select__option');
    $('.js-custom-select__option:first-child').addClass('is-active');
    $selectOpen.on('click', function (e) {
        e.preventDefault();
        let $unit = $(this).closest('.js-custom-select');

        $unit.find('.js-custom-select__list').slideToggle();
        $(this).toggleClass('is-active');
    });

    $selectOption.on('click', function () {
        let $unit = $(this).closest('.js-custom-select'),
            $name = $unit.find('.js-custom-select__name'),
            valSelect = $(this).text();
        $name.text(valSelect);
        $unit.find('.js-custom-select__list').slideUp();
    });
}

window.initCustomSelect();